import * as actionTypes from "utils/redux/action";

export const initialState = {
  open: false,
  type: null,
};

const resumeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESUME_TOGGLE_DIALOG:
      return {
        ...state,
        open: !state.open,
        type: null,
      };

    case actionTypes.RESUME_SET_TYPE:
      return {
        ...state,
        open: state.open,
        type: action.model,
      };

    default:
      return state;
  }
};

export default resumeReducer;
